import FACET_CODES from '../constants/facetCodes';
import ActionTypes from '../constants/actionTypes';
import { facetDefaults } from './defaultStates';

export default function(state = facetDefaults, action) {
  switch (action.type) {
    case ActionTypes.UPDATE[FACET_CODES.MANUFACTURER]:
      return {
        fetchSucceeded: true,
        values: action.payload,
        isFetching: false,
        selected: ''
      };
    case ActionTypes.REQUEST[FACET_CODES.MANUFACTURER]:
      return { ...state, isFetching: true };
    case ActionTypes.FAILED2FETCH[FACET_CODES.MANUFACTURER]:
      return { ...state, fetchSucceeded: false, isFetching: false };
    case ActionTypes.SELECT[FACET_CODES.MANUFACTURER]:
      return { ...state, selected: action.payload, isFetching: false };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_manufacturers.js